module.exports = __webpack_public_path__ + "img/5.ภาคเหนือ.a5df2938.jpg";